export default __webpack_public_path__ + "static/media/painting23.1a0a3669.jpeg";